import { useRouter, type RouteLocationRaw } from "vue-router";

export const useRowNavigation = () => {
  const router = useRouter();
  const openRow = (to: RouteLocationRaw, event?: MouseEvent | KeyboardEvent) => {
    const newTab = event && (event.metaKey || event.ctrlKey || (event as MouseEvent).button === 1);
    if (newTab) window.open(router.resolve(to).href, "_blank");
    else router.push(to);
  };
  return { openRow };
};
